<template>
  <div class='product-view-wrapper'>
    <div class='container'>
      <div v-if='!requestErrored && productData'>
        <div class='product-view-item'>
          <div class='product-photo'>
            <app-image
              :width="512"
              :height="768"
              :lazy-src="productData.original"
              :alt="productData.name"
            />
          </div>
          <div class='product-text app-text paragraph-s'>
            <div class='product-view-title mb-l'>
              <h3 class='h3-title' v-if="!isAdmin">
                <span class='text-italic'>{{ productArticle(productData.category) }} "{{ productData.name || productData.code }}"</span>
              </h3>
              <div v-else>
                <span class='fw-bold mr-m'>Назва:</span>
                <input type="text" class='app-input app-input-asset app-input-middle' placeholder="Назва" v-model="adminForm.name" maxlength="60">
              </div>
            </div>
            <div class='mb-m'>
              <span class='fw-bold mr-m'>Опис:</span>
              <span v-if="!isAdmin">{{ productData.description || 'не заповнено' }}</span>
              <textarea class='app-textarea app-textarea-asset app-textarea-middle' v-model="adminForm.description" v-else placeholder="Опис" maxlength="512"></textarea>
            </div>
            <div class='mb-m' v-if='productData.code'>
              <span class='fw-bold mr-m'>Код товару:</span>{{ productData.code }}
            </div>
            <div class='mb-l finish-edit-btn' v-if="isAdmin">
              <button class='app-btn app-btn-primary' @click="editProduct()">Завершити редагування</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if='error'>
        <div class='text-primary paragraph mb-l'>
          Не вдалося отримати товар. Код помилки: №{{ error.status }}.
        </div>
        <button class='app-btn app-btn-primary outline' v-if='error.status !== 404'>Спробувати ще раз</button>
        <router-link tag='div' class='text-asset d-flex align-items-center c-p' to='/products' v-else>
          <v-icon name='arrow-left' scale='0.8' class='mr-s'></v-icon>
          <span>Повернутися до списку товарів</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router.js'
import AppImage from '@/components/common/AppImage.vue'
import productArticleFunction from '@/utils/productArticle.js'

export default {
  name: 'ProductView',
  components: {
    AppImage
  },
  data () {
    return {
      productData: null,
      requestErrored: false,
      error: null,
      count: 1,
      isAdmin: false,
      adminForm: {
        name: null,
        description: null
      }
    }
  },
  methods: {
    productArticle (id) {
      return productArticleFunction(id)
    },
    getProduct (id) {
      this.$store.dispatch('getProductById', id).then(
        (data) => {
          this.productData = data
          this.adminForm.name = data.name
          this.adminForm.description = data.description
        },
        (error) => {
          console.log(error)
          this.requestErrored = true
          this.error = error
        }
      )
    },
    addToBasket () {
      const basketItem = {
        product: this.productData,
        count: Number(this.count)
      }
      const userBasket = JSON.parse(this.checkLocalBasket())
      const inBasket = userBasket.find(
        (el) => el.product.id === basketItem.product.id
      )
      if (inBasket) {
        inBasket.count = inBasket.count + basketItem.count
      } else {
        userBasket.push(basketItem)
      }
      localStorage.setItem('user_basket', JSON.stringify(userBasket))
    },
    checkLocalBasket () {
      const localBasket = localStorage.getItem('user_basket')
      return localBasket || '[]'
    },
    checkToken () {
      const token = localStorage.getItem('auth_token')
      if (token) {
        const obj = { jwt: token }
        this.$store.dispatch('verifyUser', obj).then(
          (data) => {
            this.isAdmin = data.role === 'admin'
          },
          () => {
            this.isAdmin = false
          }
        )
      }
    },
    editProduct () {
      const obj = {
        id: this.$route.params.id,
        name: this.adminForm.name,
        description: this.adminForm.description,
        jwt: localStorage.getItem('auth_token')
      }
      this.$store.dispatch('editProductById', obj).then(
        (data) => {
          if (data.status === 200) {
            router.replace('/products')
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    redirectToOtherPage (path) {
      router.push(path)
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getProduct(id)
    this.checkToken()
  }
}
</script>

<style lang='scss' scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.product-view-wrapper {
  padding: 50px 0px;
  min-height: 768px;

  .product-view-item {
    display: flex;

    .product-photo {
      margin-right: 20px;
      min-width: 512px;
    }

    .product-text {
      display: flex;
      flex-direction: column;

      .direction-buttons {
        width: 320px;
      }
    }
  }
}

@media(max-width: $laptop) {
  .product-view-wrapper {
    padding: 25px 0px;

    .product-view-item {
      display: flex;
      flex-direction: column;

      .product-photo {
        margin-right: 20px;
        margin-bottom: 25px;
        min-width: 0;
        text-align: center;
      }

      .product-text {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

@media(max-width: $mobile) {
  .finish-edit-btn {
    display: flex;
    justify-content: flex-end;
  }

  .product-view-wrapper {
    .product-view-item {
      .product-text {
        .direction-buttons {
          width: 100%;
        }
      }
    }
  }
}
</style>
